import { Injectable } from '@angular/core';
import { Routes } from '@angular/router';

import { MenuItem, MenuSection } from '../../core/models/menu-item.model';
import { MenuRegistryService } from '../../core/services/menu-registry.service';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';
import { FleetManagementComponent } from './components/fleet-management.component';
import { LicenseManagementComponent } from './components/license-management.component';
import { VesselRegistryComponent } from './components/vessel-registry.component';

const routes: Routes = [
  {
    path: 'fleet-management',
    component: FleetManagementComponent,
    data: { title: 'fleet-management.title' },
  },
  {
    path: 'vessel-registry',
    component: VesselRegistryComponent,
    data: { title: 'vessel-registry.title' },
  },
  {
    path: 'license-management',
    component: LicenseManagementComponent,
    data: { title: 'license-management.title' },
  },
];
const menuItems: MenuItem[] = [
  {
    id: 'ship-owners',
    name: 'Permisionarios',
    type: 'entity',
    dataSource: { url: 'catalogs/ship-owners' },
    icon: 'person_4',
    order: 1,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesShipOwners,
      AppActions.Read
    ),
  },
  {
    id: 'biologists',
    name: 'Biólogos',
    type: 'entity',
    dataSource: { url: 'catalogs/biologists' },
    icon: 'person_4',
    order: 2,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesBiologists,
      AppActions.Read
    ),
  },
  {
    id: 'captains',
    name: 'Capitanes',
    type: 'entity',
    dataSource: { url: 'catalogs/captains' },
    icon: 'badge',
    order: 3,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesCaptains,
      AppActions.Read
    ),
  },
  {
    id: 'coast-guards',
    name: 'Guardacostas',
    type: 'entity',
    dataSource: { url: 'catalogs/coast-guards' },
    icon: 'group',
    order: 4,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesCoastGuards,
      AppActions.Read
    ),
  },
  {
    id: 'inspectors',
    name: 'Inspectores',
    type: 'entity',
    dataSource: { url: 'catalogs/inspectors' },
    icon: 'person_4',
    order: 5,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesInspectors,
      AppActions.Read
    ),
  },
  {
    id: 'vessels',
    name: 'Embarcaciones',
    type: 'entity',
    dataSource: { url: 'catalogs/vessels' },
    icon: 'directions_boat',
    order: 6,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesShips,
      AppActions.Read
    ),
  },
  {
    id: 'species',
    name: 'Especies',
    type: 'entity',
    dataSource: { url: 'catalogs/species' },
    icon: 'set_meal',
    order: 7,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesSpecies,
      AppActions.Read
    ),
  },
  {
    id: 'docks',
    name: 'Muelles',
    type: 'entity',
    dataSource: { url: 'catalogs/docks' },
    icon: 'warehouse',
    order: 8,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesDocks,
      AppActions.Read
    ),
  },
  {
    id: 'ports',
    name: 'Puertos',
    type: 'entity',
    dataSource: { url: 'catalogs/ports' },
    icon: 'anchor',
    order: 9,
    neededClaim: getClaimString(
      AppFeature.ReferenceTablesPorts,
      AppActions.Read
    ),
  },
];

const menuSection: MenuSection = {
  id: 'fleet-management',
  name: 'Tablas de Referencia',
  items: menuItems,
  order: 4,
  neededClaim: getClaimString(AppFeature.ReferenceTables, AppActions.Read),
};

@Injectable({
  providedIn: 'root',
})
export class FleetManagementModule {
  constructor(private menuRegistry: MenuRegistryService) {
    // Self-register menu items only
    // Routes are now handled by standard Angular routing in app.routes.ts
    this.menuRegistry.registerModule(menuSection);
  }

  /**
   * Static method to get menu items (for external access)
   */
  static getMenuItems(): MenuItem[] {
    return menuItems;
  }

  /**
   * Static method to get routes (for external access)
   */
  static getRoutes(): Routes {
    return routes;
  }
}
